import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useSelector } from 'react-redux';
import { hasPurchaseMotionsFailedSelector } from '../../../selectors/LoadingStateSelectors';

// When an error state is decoupled from the catch-all hasPricingAndPurchasingFailed selector
// We can pull in the individual fail state here and surface specific language to users
import { jsx as _jsx } from "react/jsx-runtime";
const FallbackErrorBanner = () => {
  const hasPurchaseMotionsFailed = useSelector(hasPurchaseMotionsFailedSelector);
  if (hasPurchaseMotionsFailed) {
    return /*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "failedPurchaseMotionsBanner.title"
      }),
      type: "danger",
      marginBlockEnd: "400",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "failedPurchaseMotionsBanner.description"
      })
    });
  }
  return null;
};
export default FallbackErrorBanner;